import { InstitutionAttributesMap } from "../interfaces/Institution";


export const OPERATOR_CURRENCY_MAP: Record<string, string> = {
    BE: 'EUR', DE: 'EUR', ES: 'EUR', FR: 'EUR', IE: 'EUR', IT: 'EUR', NL: 'EUR', PT: 'EUR',
    CH: 'CHF', CZ: 'CZK', GB: 'GBP', HU: 'HUF', PL: 'PLN', RO: 'RON'
};

const getLemonwayBasePart = (attributes: InstitutionAttributesMap, operator: string, currency: string) => {
    const opAttrs = attributes[operator] || attributes[Object.keys(attributes)[0]];
    if (!opAttrs) return null;

    const baseUrl = opAttrs.find(a => a.key === 'lemonway.base.url')?.value;
    if (!baseUrl) return null;

    const boHost = baseUrl.includes('sandbox')
        ? 'https://sb-bo.lemonway.com'
        : 'https://dashboard.lemonway.com';

    const countrySuffix = currency === 'EUR' ? 'eur' : currency.substring(0, 2).toLowerCase();

    return `${boHost}/decathlon${countrySuffix}`;
};


export const generateEscrowLemonwayUrl = (attributes: InstitutionAttributesMap | null | undefined, operator: string, currency: string) => {
    if (!attributes) return null;

    const basePart = getLemonwayBasePart(attributes, operator, currency);
    const accountId = attributes[operator]?.find(a => a.key === 'lemonway.escrow.institution.account.id')?.value;

    if (!basePart || !accountId) return null;

    return `${basePart}/wallets/${accountId}/overview`;
};


export const generateSCLemonwayUrl = (attributes: InstitutionAttributesMap | null | undefined, currency: string) => {
    console.log("SCLEMEONWAY", attributes)
    if (!attributes) return null;

    const targetOp = currency === 'EUR' 
        ? (attributes['FR'] ? 'FR' : Object.keys(attributes)[0]) 
        : currency.substring(0, 2).toUpperCase();

    const basePart = getLemonwayBasePart(attributes, targetOp, currency);
    if (!basePart) return null;

    return `${basePart}/my-wallet/overview`;
};